import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#f3f3f3',
    color100: '#e6e6e6',
    color200: '#cccccc',
    color300: '#b3b3b3',
    color400: '#999999',
    color500: '#808080',
    color600: '#666666',
    color700: '#4d4d4d',
    color800: '#333333',
    color900: '#1a1a1a'
  },
  default: {
    color50: '#d5dee5',
    color100: '#aabdcc',
    color200: '#809cb2',
    color300: '#557a98',
    color400: '#2b597f',
    color500: '#003865',
    color600: '#002d51',
    color700: '#00223d',
    color800: '#001628',
    color900: '#000b14'
  },
  accent: {
    color50: '#dcf8f6',
    color100: '#b8f0ed',
    color200: '#95e9e4',
    color300: '#71e1db',
    color400: '#4edad2',
    color500: '#2ad2c9',
    color600: '#22a8a1',
    color700: '#197e79',
    color800: '#115450',
    color900: '#082a28'
  },
  positive: {
    color50: '#d5f2e6',
    color100: '#aae4cc',
    color200: '#80d7b3',
    color300: '#55ca99',
    color400: '#2bbc80',
    color500: '#00af66',
    color600: '#008c52',
    color700: '#00693d',
    color800: '#004629',
    color900: '#002314'
  },
  negative: {
    color50: '#f8d5dd',
    color100: '#f1aabb',
    color200: '#ea8099',
    color300: '#e35576',
    color400: '#dc2b54',
    color500: '#d50327',
    color600: '#aa0028',
    color700: '#80001e',
    color800: '#550014',
    color900: '#2a000a'
  },
  special: {
    color50: '#ffe1d5',
    color100: '#fec3ab',
    color200: '#fea681',
    color300: '#fd8856',
    color400: '#fd6a2c',
    color500: '#fc4c02',
    color600: '#ca3d02',
    color700: '#972e01',
    color800: '#651e01',
    color900: '#320f00'
  }
};

const variant: ACPVariant = {
  id: 'www.netspendskylight.com',
  productTitle: 'Netspend Skylight Account',
  productType: 'baw_dda',
  accessDomain: {
    subdomain: 'www',
    domain: 'netspendskylight',
    topLevelDomain: 'com'
  },
  colors,
  legacyAcpTheme: 'netspend-skylight',
  legacyAcpBrandName: 'netspend-skylight',
  legacyLegosTheme: 'skylight-all-access',
  status_bar_background_color: colors.default.color500,
  status_bar_foreground_color: 'dark',
  contactInfo: {
    name: 'Netspend ',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@netspendskylight.com',
    fax_formatted: '(512) 857-0263',
    phone_formatted: '(800) 269-4674',
    phone: '8002694674',
    phone_international: '737-220-8956',
    balance_check_phone: '8663877363',
    balance_check_phone_formatted: '1-866-387-7363',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      appsFlyerBannerKey: 'e6d258bc-ae06-49ed-9b49-10fe3ee7a2ee',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: false,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: false,
      showScanCardRegistration: true,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: true,
      showReloadLocationLink: true
    },
    misc: {
      contactRecipient: 'Netspend',
      layoutComponentOverride: false,
      layoutAppBarInverted: false,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#0092BC',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#84bd00',
      marketingSiteUrl: 'https://www.netspendskylight.com',
      marketingSiteLinkText: 'NetspendSkylight.com',
      locationSearchMax: '25',
      iOSAppId: '872717411'
    },
    content: {},
    disclaimers: {},
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'dda-activation',
      'skylight-all-access-checks',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
